import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import GetAppIcon from '@mui/icons-material/GetApp';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { withStyles } from '@mui/styles';

import { useForm } from 'react-hook-form';
import styled from '@emotion/styled';
import {
  getAllBillingRoles,
  searchEmployee
} from 'src/services/employeeService';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import {
  getAllEmployeesTimeSheet,
  getMonthlyHours
} from 'src/services/timesheetService';
import { TableColumnCell } from 'src/components/TableColumnCell';
import moment from 'moment';

interface Filters {
  type: string;
  po_status: string;
  status: string;
  cat: string;
}

const applyFilters = (employees: any[], filters: Filters): any[] => {
  return employees.filter((employeeStatus) => {
    let matches = true;
    // if (filters.status && employeeStatus.status !== filters.status) {
    //   matches = false;
    // }
    return matches;
  });
};

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const ResourceMonthlyHours = () => {
  const navigate = useNavigate();
  const [toggleFilter, setToggleFilter] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [sortIdType, setSortIdType] = useState('desc');
  const [filters, setFilters] = useState<Filters>({
    type: null,
    po_status: null,
    status: null,
    cat: null
  });
  var initalList: any[] = [];
  const [employees, setEmployees] = useState(initalList);

  let initialProjectFilterValues = {
    designation: null,
    client: null,
    from: null,
    to: null
  } as any;

  const { register, handleSubmit, reset, getValues, setValue } = useForm<any>({
    defaultValues: initialProjectFilterValues
  });
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (employees?.length > 0 && sortIdType === 'asc') {
      setEmployees(employees.sort((a, b) => a.name.localeCompare(b.name)));
    } else if (employees?.length > 0 && sortIdType === 'desc') {
      setEmployees(employees.sort((a, b) => b.name.localeCompare(a.name)));
    }
  }, [employees, sortIdType]);

  const filteredEmployees = applyFilters(employees, filters);

  const paginatedEmployees = applyPagination(filteredEmployees, page, limit);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const getEmployeeData = () => {
    getMonthlyHours().then((res) => {
      setEmployees((res.data as any[]) || []);
    });
  };

  useEffect(() => {
    getEmployeeData();
  }, []);

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const [empFilter, setEmpFilter] = useState({} as any);

  const onSubmit = (data: any) => {
    searchEmployee(data).then((res) => {
      setEmployees((res.data as any[]) || []);
    });
  };

  const resetFilterResult = () => {
    reset();
    setEmpFilter(initialProjectFilterValues);
    getEmployeeData();
  };

  //when user started to type the name in the text field
  const nameChange = (event) => {
    if (event.target.value.length > 2) {
      setValue('name', event.target.value);
      searchEmployee(getValues() as any).then((res) => {
        setEmployees(res.data as any[]);
      });
    }

    if (event.target.value.length === 0) {
      getEmployeeData();
    }
  };

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
                        .MuiCardHeader-action{
                          width: 100%
                        }
                      `
  );

  useEffect(() => {
    const isNullish = Object.values(empFilter).every((value) => {
      if (value === null) {
        return true;
      }

      return false;
    });

    if (Object.keys(empFilter).length === 0 || isNullish) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [empFilter]);

  useEffect(() => {
    getAllBillingRoles();
  }, []);

  const billingRoles = useSelector(
    (state: RootStateType) => state.employeeReducer.billingRoles
  );
  const tracks = useSelector(
    (state: RootStateType) => state.employeeReducer.tracks
  );

  return (
    <>
      <PageTitleWrapper>
        <Grid container alignItems="center" direction={'row'}>
          <Grid item>
            <Typography
              onClick={() => {
                navigate('/dashboard');
              }}
              style={{ cursor: 'pointer' }}
              variant="h4"
              component="h4"
            >
              {' '}
              Dashboard /&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h4"
              component="h4"
            >
              Projects - Resource Monthly Total Hours Spent
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-end"
            style={{ marginLeft: 'auto' }}
          >
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              startIcon={<GetAppIcon fontSize="small" />}
              style={{ height: '1.75rem' }}
              // onClick={handleClickOpen}
            >
              Download Report
            </Button>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Card>
          <Grid
            container
            style={{
              justifyContent: 'space-between',
              padding: '1rem 1rem 0rem 1rem'
            }}
            spacing={2}
          >
            <Grid item xs={6}>
              <TextField
                sx={{ width: 150, mr: 2 }}
                size="small"
                placeholder="Search..."
                onChange={(e) => nameChange(e)}
                InputProps={{
                  style: { fontSize: '12px', height: '1.75rem' },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{ color: '#d3d3d3' }}
                        style={{ fontSize: '15px' }}
                      />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                sx={{
                  mt: { xs: 2, md: 0 },
                  color: `${!toggleFilter && 'gray'}`
                }}
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => {
                  setToggleFilter(!toggleFilter);
                }}
                style={{ height: '1.75rem', fontSize: '12px' }}
              >
                Filters
              </Button>
            </Grid>
          </Grid>
          <CardHeaderWrapper
            action={
              <>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {toggleFilter ? (
                    <>
                      <Grid
                        container
                        sx={{ pr: 2 }}
                        spacing={2}
                        style={{
                          paddingTop: 3,
                          paddingBottom: 2,
                          justifyContent: 'space-between'
                        }}
                      >
                        <Grid item xs={3}>
                          <InputLabel
                            style={{
                              fontSize: '12px'
                            }}
                          >
                            Designation
                          </InputLabel>
                          <FormControl fullWidth>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              {...register('designation')}
                              value={empFilter.designation}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  designation: e.target.value
                                }));
                                setValue('designation', e.target.value);
                              }}
                            >
                              {(billingRoles || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <InputLabel
                            style={{
                              fontSize: '12px'
                            }}
                          >
                            Client
                          </InputLabel>
                          <FormControl fullWidth>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              value={empFilter.client}
                              {...register('client')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  client: e.target.value
                                }));
                                setValue('client', e.target.value);
                              }}
                            >
                              {(paginatedEmployees || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <InputLabel
                            style={{
                              fontSize: '12px'
                            }}
                          >
                            From
                          </InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              InputProps={{
                                style: { fontSize: '12px', height: '2rem' }
                              }}
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '1.5rem'
                              }}
                              size="small"
                              type="date"
                              placeholder="DD/MM/YYYY"
                              value={moment(empFilter.from).format(
                                'YYYY-MM-DD'
                              )}
                              {...register('from')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  from: e.target.value
                                }));
                                setValue('from', e.target.value);
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <InputLabel
                            style={{
                              fontSize: '12px'
                            }}
                          >
                            To
                          </InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              InputProps={{
                                style: { fontSize: '12px', height: '2rem' }
                              }}
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '1.5rem'
                              }}
                              size="small"
                              type="date"
                              placeholder="DD/MM/YYYY"
                              value={moment(empFilter.to).format('YYYY-MM-DD')}
                              {...register('to')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  to: e.target.value
                                }));
                                setValue('to', e.target.value);
                              }}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{ pr: 2 }}
                        container
                        style={{ justifyContent: 'flex-end', marginTop: 4 }}
                        xs={12}
                      >
                        <Button
                          sx={{ mt: { xs: 2, md: 0 }, mr: 2 }}
                          variant="text"
                          onClick={resetFilterResult}
                          disabled={isDisabled}
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Clear
                        </Button>
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          disabled={isDisabled}
                          variant="outlined"
                          type="submit"
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Filter
                        </Button>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                </form>
              </>
            }
            title=""
          />
          <TableContainer className="hideScroll">
            <Table size="small">
              <TableHead>
                <CustomTableRow>
                  <TableHeaderCell
                    content="Project Name"
                    smallFont
                    sort
                    setSortType={setSortIdType}
                    sortType={sortIdType}
                  />
                  <TableHeaderCell
                    content="Employee Name"
                    smallFont
                    sort
                    setSortType={setSortIdType}
                    sortType={sortIdType}
                  />
                  <TableHeaderCell content="Designation" smallFont />
                  <TableHeaderCell content="Jan" smallFont />
                  <TableHeaderCell content="Feb" smallFont />
                  <TableHeaderCell content="Mar" smallFont />
                  <TableHeaderCell content="Apr" smallFont />
                  <TableHeaderCell content="May" smallFont />
                  <TableHeaderCell content="Jun" smallFont />
                  <TableHeaderCell content="Jul" smallFont />
                  <TableHeaderCell content="Aug" smallFont />
                  <TableHeaderCell content="Sep" smallFont />
                  <TableHeaderCell content="Oct" smallFont />
                  <TableHeaderCell content="Nov" smallFont />
                  <TableHeaderCell content="Dec" smallFont />
                  <TableHeaderCell content="Grand Total" smallFont />
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {paginatedEmployees &&
                  paginatedEmployees?.length > 0 &&
                  paginatedEmployees.map((listItem) => {
                    return (
                      <TableRow hover>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.name}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            -
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            -
                          </Typography>
                        </TableColumnCell>

                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 1 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 2 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 3 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 4 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 5 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 6 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 7 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 8 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 9 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 10 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 11 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.monthlySpentHours?.map((hrs) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {hrs?.month === 12 ? hrs.hours : 0}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.monthlySpentHours?.reduce(
                              (accumulator, object) => {
                                return accumulator + object.hours;
                              },
                              0
                            )}
                          </Typography>
                        </TableColumnCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* {paginatedweeklyProjectWork?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )} */}
          <Box p={2}>
            <TablePagination
              sx={{
                fontSize: '12px',
                '.MuiTablePagination-displayedRows': {
                  fontSize: '12px'
                },
                '.MuiTablePagination-selectLabel': {
                  fontSize: '12px'
                }
              }}
              component="div"
              count={filteredEmployees?.length}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default ResourceMonthlyHours;
